"use strict";

exports.__esModule = true;
exports.wrapPageElement = void 0;

var _gatsbySsr = require("./gatsby-ssr");

exports.wrapPageElement = _gatsbySsr.wrapPageElement;